import { call, put, takeEvery } from "redux-saga/effects";
import { createNewsSuccess, createNewsFailed } from ".";
import { serverIp } from "../../../utils";

export function* createNewsArticle({ payload }: any): any {
  const { title, content, genres, image, video, token } = payload;

  console.log("Saga received payload:", payload);
  console.log("Image array:", image);
  console.log("Video array:", video);

  // Create FormData for multipart/form-data submission
  const formData = new FormData();
  formData.append("title", title);
  formData.append("content", content);

  // Add optional fields
  if (genres) {
    formData.append("genres", genres);
  }

  if (image && image.length > 0) {
    // Handle single image
    console.log("Processing image...");
    const file = image[0];
    console.log("Image file:", file);
    if (file.originFileObj) {
      console.log("Appending image to FormData:", file.originFileObj.name);
      formData.append("image", file.originFileObj);
    }
  }

  if (video && video.length > 0) {
    // Handle single video
    console.log("Processing video...");
    const file = video[0];
    console.log("Video file:", file);
    if (file.originFileObj) {
      console.log("Appending video to FormData:", file.originFileObj.name);
      formData.append("video", file.originFileObj);
    }
  }

  console.log("FormData prepared and ready to send");

  const requestUrl = `${serverIp}/create_news`;

  try {
    const response = yield call(() =>
      fetch(requestUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          // Don't set Content-Type header - browser will set it with boundary for multipart/form-data
        },
        body: formData,
      })
    );

    if (!response.ok) {
      // Handle error responses
      const errorData = yield response.json();
      throw new Error(errorData.error || "Failed to create news");
    }

    const data = yield response.json();
    yield put(createNewsSuccess(data));
  } catch (err: any) {
    const errorMessage = err.message || "Failed to create news";
    yield put(createNewsFailed(errorMessage));
  }
}

function* reportNewsSaga() {
  yield takeEvery("reportNews/createNews", createNewsArticle);
}

export default reportNewsSaga;
